import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { theme, BackToTopIcon, mq } from '@kvdbil/components';
import throttle from 'lodash.throttle';
import useOnScroll from '../shared/hooks/useOnScroll';
import { animateScroll } from 'react-scroll';
import { useSelector } from 'react-redux';
import {
  isContactButtonHidden,
  isDefaultTriggerEnabledSelector
} from '../shared/selectors/global';

const Container = styled.div<{ $isHidden: boolean }>`
  position: fixed;
  right: 0.75rem;
  top: 2rem;
  z-index: 999;
  width: 3.75rem;
  height: 3.75rem;

  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;

  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.light};
  background-color: ${theme.colors.secondary.mainAlt};
  box-shadow: ${theme.elevations.elevation16};
  border-radius: 20rem;

  ${mq('tablet')} {
    display: none;
  }
`;

export const ToTopButton = () => {
  const [isAtTop, setIsAtTop] = useState(true);

  const isButtonHidden = useSelector(isContactButtonHidden);
  const isTriggerEnabled = useSelector(isDefaultTriggerEnabledSelector);

  const handleScroll = useCallback(
    (current: number) => {
      const hasScrolled = current < 190;

      if (hasScrolled !== isAtTop) {
        setIsAtTop(hasScrolled);
      }
    },
    [isAtTop]
  );

  const throttledScrollHandler = throttle(handleScroll, 200);

  useOnScroll({ onScroll: throttledScrollHandler });

  const isHidden = (isAtTop || isButtonHidden) && isTriggerEnabled;

  return (
    <Container
      $isHidden={
        (isTriggerEnabled && isHidden) || (!isTriggerEnabled && isButtonHidden)
      }
      onClick={() => {
        animateScroll.scrollToTop({
          duration: 500,
          smooth: true
        });
      }}
    >
      <BackToTopIcon height={'24px'} width={'24px'} />
    </Container>
  );
};
